// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1p9Oq","questions":"styles_questions__yO85C","footer":"styles_footer__3BSCZ"};